import React, { useState } from 'react';
import styled from 'styled-components';
import { Chips } from '@naf/chips';
import { Info } from '@styled-icons/material-outlined/Info';
import { ExpandMore } from '@styled-icons/material-outlined/ExpandMore';
import { ExpandLess } from '@styled-icons/material-outlined/ExpandLess';
import { nafColor } from '@nafcore/theme';
import { animation, breakpoints, spacing, radius } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { propValidationConfig } from './propValidationConfig';
export const InfoBox = ({
  highlightedText,
  title,
  content,
  displayColor = 'standard'
}) => {
  const [infoBoxOpen, setinfoBoxOpen] = useState(false);
  if (highlightedText) highlightedText = highlightedText.trim();
  return /*#__PURE__*/React.createElement(BlockWrapper, {
    className: infoBoxOpen ? 'open' : 'closed',
    borderColor: displayColor
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    withPadding: (highlightedText?.length ?? 0) > 0,
    backgroundColor: displayColor
  }, highlightedText && /*#__PURE__*/React.createElement(Text, {
    variant: TextVariant.Small
  }, highlightedText), !highlightedText && /*#__PURE__*/React.createElement(Info, {
    size: 24
  })), /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(DocumentHeader, {
    variant: TextVariant.ArticleTextLargeHeader,
    tag: "h3"
  }, title), content), /*#__PURE__*/React.createElement(InfoBoxToggler, null, /*#__PURE__*/React.createElement(Chips, {
    variant: "moss",
    text: infoBoxOpen ? `Skjul` : `Les mer`,
    icon: infoBoxOpen ? /*#__PURE__*/React.createElement(ExpandLess, {
      size: 16
    }) : /*#__PURE__*/React.createElement(ExpandMore, {
      size: 16
    }),
    onClick: () => {
      setinfoBoxOpen(!infoBoxOpen);
    }
  })));
};
const displayOptions = {
  standard: nafColor?.primary?.spruce || '#062e2a',
  green: nafColor?.primary?.kart || '#7BDB83'
};
const IconWrapper = styled.div.withConfig(propValidationConfig)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.backgroundColor === 'standard' ? '#FFF' : '#000'};
  padding: 0 ${props => props.withPadding ? '1rem' : '0.1rem'};
  position: absolute;
  min-width: 32px;
  height: 32px;
  left: ${spacing.space40};
  top: -16px;
  border-radius: 2rem;
  background: ${props => displayOptions[props.backgroundColor]};

  @media (max-width: ${breakpoints.s}) {
    left: ${spacing.space24};
  }
`;
const TextWrapper = styled.div`
  overflow: hidden;
  max-height: inherit;
  > p,
  h3,
  h2,
  h4,
  a,
  ul {
    margin-bottom: ${spacing.space24} !important;
  }
`;
const InfoBoxToggler = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -20px;
  z-index: 5;
`;
const BlockWrapper = styled.div.withConfig(propValidationConfig)`
  margin: ${spacing.space16} 0 ${spacing.space64} 0;
  padding: 0;
  border: 1px solid ${props => displayOptions[props.borderColor]};
  border-radius: ${radius.s || '2px'};
  padding: ${spacing.space40};
  position: relative;

  @media (max-width: ${breakpoints.s}) {
    padding: ${spacing.space24};
  }

  &.open {
    max-height: 1000px;
    transition: max-height 0.7s ${animation.easeIn};
  }

  &.closed {
    border-bottom: 0;
    padding-bottom: 0;
    max-height: 146px;
    transition: max-height 0.7s ${animation.easeOut};
    ${InfoBoxToggler} {
      bottom: -5px;
    }
    &:after {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
      content: ' ';
      width: 105%;
      height: 98px;
      display: block;
      position: absolute;
      left: -5px;
      bottom: 0;
      z-index: 1;
    }
    @media (max-width: ${breakpoints.s}) {
      max-height: 180px;
    }
  }
`;
const DocumentHeader = styled(Text)`
  margin: 0 !important;
`;
//# sourceMappingURL=info-box.js.map